import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutPage.css'; // même feuille de style (couleurs et grille) que AboutPage

import jeanClaudeImage from '../images/JeanClaudePhoto.jpg';
import emileImage from '../images/EmilePhoto.jpg';
import flaubertImage from '../images/FlaubertPhoto.jpg';
import antoineImage from '../images/AntoinePhoto.jpg';
import christianImage from '../images/ChristianPhoto.jpg';

export default function WaterCommissionPage() {
  const { t } = useTranslation();

  // Membres de la commission d'eau — la clé `postKey` pointe vers le
  // libellé du poste dans fr.json / en.json (menu.<postKey>).
  const membres = [
    { nom: 'Jean Claude Tchatchet', image: jeanClaudeImage, postKey: 'commissionPresident' },
    { nom: 'Émile Tchaptchet', image: emileImage, postKey: 'commissionMember' },
    { nom: 'Jean-Flaubert Mougou', image: flaubertImage, postKey: 'commissionMember' },
    { nom: 'Antoine Ngoyou', image: antoineImage, postKey: 'commissionMember' },
    { nom: 'Christian Njeumen', image: christianImage, postKey: 'commissionMember' },
  ];

  return (
    <div className="about-page">
      {/* En-tête (même bannière marron que AboutPage) */}
      <header className="about-hero">
        <h1>{t('menu.waterCommissionTitle')}</h1>
        <p className="about-subtitle">{t('menu.waterCommissionSubtitle')}</p>
      </header>

      {/* Grille des membres, centrée, 3 colonnes — identique à AboutPage */}
      <section className="about-grid">
        {membres.map((membre, index) => (
          <div className="profile-card" key={`${membre.nom}-${index}`}>
            <img
              className="profile-photo"
              src={membre.image}
              alt={membre.nom}
              width={220}
              height={220}
            />
            <h2 className="profile-nom">{membre.nom}</h2>
            <p className="profile-poste">{t(`menu.${membre.postKey}`)}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
